<template>
  <div id="container" class="ZoneSettings">
    <div class="affix-holder d-none d-sm-block">
      <affix class="affix" relative-element-selector="#container" :offset="{ top: 0, bottom: 0 }">
        <progress-tracker :steps="progressSteps"></progress-tracker>
      </affix>
    </div>
    <general-zone-information circled-num="1" :zone="zone"></general-zone-information>

    <ad-format circled-num="2" v-model="zone"></ad-format>
    <!--<ad-format v-if="zone.integration !== 'RTB'" circled-num="2" v-model="zone"></ad-format> -->

    <!--
    <prebid-remote-container v-model="zone" v-if="zone.integration === 'PBIAB'"></prebid-remote-container>
    <prebid-bidders v-model="zone" :server-only="zone.integration !== 'PBIAB'"></prebid-bidders>
    -->

    <global-settings circled-num="3" v-model="zone"></global-settings>

    <div class="row m-sm-4 my-4">
      <b-col xs="6">
        <b-btn variant="outline-secondary">Back</b-btn>
      </b-col>
      <b-col xs="6" class="text-right mt-3 mt-sm-0">
        <b-btn :disabled="!readyToContinue" @click="create()" variant="primary">Next Step</b-btn>
      </b-col>
    </div>
  </div>
</template>


<style scoped>
  .ZoneSettings >>> .affix-holder {
    height: 6.5rem;
  }

  .ZoneSettings >>> .vue-affix {
    margin: 0 -1.5rem 0 -1.5rem;
    width: calc(100% + 3rem);
    height: 7rem;
    background: var(--light);
    border-top: 2px solid var(--border);
    border-bottom: 2px solid var(--border);
    z-index: 500;
  }

  .ZoneSettings >>> .vue-affix.affix {
    width: calc(100% + 3rem - 128px);
  }

  @media (min-width: 768px) {
    .ZoneSettings >>> .vue-affix {
      height: 6rem;
    }
  }

  @media (min-width: 992px) {
    .ZoneSettings >>> .vue-affix.affix {
      width: calc(100% + 3rem - 278px);
    }
  }

  @media (min-width: 1200px) {
    .ZoneSettings >>> .vue-affix {
      height: 5rem;
    }
  }

  .ZoneSettings >>> .circled-number {
    font-weight: bold;
    color: var(--primary);
    border-radius: 50%;
    border: 2px solid #e3eaef;
    width: 1.7em;
    height: 1.7em;
    padding-top: 0.15em;
    text-align: center;
  }
</style>

<script type="text/javascript">
    import ProgressTracker from '@/components/ProgressTracker'
    import GeneralZoneInformation from '@/publisher/pages/Zone/ZoneSettings/GeneralZoneInformation'
    import ContainerInformation from '@/publisher/pages/Zone/ZoneSettings/ContainerInformation'
    import PrebidBidders from './Zone/PrebidBidders'
    import PrebidRemoteContainer from './Zone/PrebidRemoteContainer'
    import AdFormat from '@/publisher/pages/Zone/ZoneSettings/AdFormat'
    import GlobalSettings from '@/publisher/pages/Zone/ZoneSettings/GlobalSettings'
    import {PublisherApi} from '@/publisher/api'
    import {toggleInArray} from '@/components/utils.js'

    export default {
        props: {
            cid: {required: true, type: String},
            mid: {required: true, type: String},
            zid: {required: false, type: String}
        },
        data() {
            return {
                zone: {
                    company_id: this.cid,
                    med_id: this.mid,
                    bidfloor: 0.0,
                    tmax: 750,
                    ad_formats: ['BANNER'],
                    banner: this.defaultBanner(),
                    video: this.defaultVideo(),
                    pos: 'UNKNOWN',
                    backup_tag: {},
                    integration: 'PREBIDJS',
                    bidders: [ ],
                    pmp_only: false,
                    container: {
                      type: 'SIMPLE',
                      lazy_load: true
                    }
                }
            }
        },
        methods: {
            toggleInArray,
            defaultBanner() {
                return {
                    blocked_attrs: [],
                    blocked_types: [],
                    apis: [],
                    dimensions: []
                }
            },
            defaultVideo() {
                return {
                    player_dimension: [ 480, 270 ],
                    autoplay: 'AUTO_SOUNDOFF',
                    min_duration: 0,
                    max_duration: 30,
                    skippable: false,
                    apis: [],
                    linear: false
                }
            },
            create() {
                console.log(this.zone.video)
                PublisherApi.publisherTagSet(this.zone).then((tag) => {
                    this.$notify.success('Tag Saved')
                    if(!this.zid) {
                        this.$router.push({name: 'TagIntegrationCode', params: {cid: this.cid, mid: this.mid, zid: tag.id}})
                    } else {
                        this.$router.go(-1)
                    }

                }, (err) => {
                    this.$notify.error(err)
                })
            }
        },
        computed: {
            readyToContinue() {
                return this.generalZoneInformationDone && this.adFormatsDone && this.globalSettingsDone;
            },
            progressSteps() {
                return [
                    {
                        active: this.generalZoneInformationDone,
                        text: 'General Zone Information',
                        selector: '#generalZoneInformation'
                    },
                    {active: this.adFormatsDone, text: 'Ad Formats', selector: '#adFormats'},
                    {active: this.globalSettingsDone, text: 'Global Settings', selector: '#globalSettings'},
                    {active: false, text: 'Integration Code'}
                ]
            },
            generalZoneInformationDone() {
                return this.zone.name !== '';
            },
            adFormatsDone() {
                //at least one toggle must be selected
                if (this.zone.ad_formats.length === 0) {
                    return false;
                }
                //if banner toggle is on, some attributes must be filled
                let bannerCompleted = !this.zone.ad_formats.includes('BANNER') || (this.zone.banner.dimensions.length !== 0);
                //if video toggle is on, some attributes must be filled
                let vdim = this.zone.video.player_dimension
                let videoCompleted = this.zone.ad_formats.includes('VIDEO') ? (this.zone.video && vdim && vdim.length && this.zone.video.linear !== undefined) : true
                return bannerCompleted && videoCompleted;
            },
            globalSettingsDone() {
                return this.zone.tmax > 0;
            }
        },
        mounted() {
            if (this.zid) {
                PublisherApi.tagDetails(this.cid, this.mid, this.zid)
                    .then((zone) => {
                        this.zone = Object.assign({ video: this.defaultVideo(), banner: this.defaultBanner(), container: { type: 'SIMPLE', lazy_load: true }, bidders: [] }, zone)
                    })
                    .catch((e) => this.$notify.error('Error Loading Zone: ' + e.errorMessage))
            }
        },
        components: {
            ProgressTracker,
            GeneralZoneInformation,
            ContainerInformation,
            AdFormat,
            GlobalSettings,
            PrebidBidders,
            PrebidRemoteContainer
        }
    }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/PublisherZoneSettings.vue